import role from "@boot/middleware/role";
import Router from "@services/router";
import MainTemplate from "@components/templates/Main";
import AdminRoutes from "./admin/routes";
import InvitePage from "./customer/components/pages/Invite";
import invited from "./customer/middleware/invited";
import CustomerRoutes from "./customer/routes";
import loggedIn from "@boot/middleware/loggedIn";

export default [
    Router.group({ middleware: invited() }, [
        Router.group({ middleware: role("customer") }, [
            Router.group({ template: MainTemplate }, [
                Router.page({ name: "club:customer:invite", path: "/app/group/invite/:secret", component: InvitePage }),
            ])
        ])
    ]),
    Router.group({ middleware: loggedIn() }, [
        Router.group({ template: MainTemplate }, [
            Router.group({ middleware: role("customer") }, CustomerRoutes),
            Router.group({ middleware: role("admin") }, AdminRoutes)
        ])
    ])
]